import Method from './Method';

export default Method;